import { Row, Col } from 'antd'
import AffectedValues from '../AffectedValues'
import { SingleStatusReversalProps } from './types'
import { CommonWorkflowRollbackModalProps } from '../../types'
import Message from '../Message'

const SingleStatusReversal: React.FC<
  SingleStatusReversalProps &
    Pick<CommonWorkflowRollbackModalProps<any>, 'recordName'>
> = ({ endStatus, affectedItems, formItems, recordName }) => {
  return (
    <>
      <Message recordName={recordName} status={endStatus} />
      <Row gutter={16}>
        <Col sm={12}>
          <AffectedValues items={affectedItems} />
        </Col>
        <Col sm={12}>{formItems}</Col>
      </Row>
    </>
  )
}

export default SingleStatusReversal
